import { TdsItem } from '@tencent/tds-ui/src/enum/tds';
import { TdsFooter } from '@tencent/tds-ui/src/tds-footer';
import { TdsNavigation } from '@tencent/tds-ui/src/tds-navigation';
import { Button } from 'antd';
import classNames from 'classnames';
import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import BrandLogo from '@/assets/images/header/brand-logo.svg?react';
import RightArrow from '@/assets/images/header/right-arrow.svg?react';
import AlertIcon from '@/assets/images/index-mobile/alert.react.svg?react';
import HomeAnimationIcon from '@/assets/images/index-mobile/animation.react.svg?react';
import CoreIcon from '@/assets/images/index-mobile/core.react.svg?react';
import ExtraIcon from '@/assets/images/index-mobile/extra.react.svg?react';
import InfoIcon from '@/assets/images/index-mobile/info.react.svg?react';
import JuleiIcon from '@/assets/images/index-mobile/julei.react.svg?react';
import MetricIcon from '@/assets/images/index-mobile/metric.react.svg?react';
import ReportIcon from '@/assets/images/index-mobile/report.react.svg?react';
import UserListIcon from '@/assets/images/index-mobile/user-list.react.svg?react';
import alert from '@/assets/images/page/alert.png';
import analyticalAbility from '@/assets/images/page/analytical-ability.png';
import appList from '@/assets/images/page/app-list.png';
import daily from '@/assets/images/page/daily.png';
import indicator from '@/assets/images/page/indicator.png';
import info from '@/assets/images/page/info.png';
import monitor from '@/assets/images/page/monitor.png';
import strategy from '@/assets/images/page/strategy.png';
import { MultiApp } from '@/config/context';
import { isInternal } from '@/infrastructure/auth';
import { ENV } from '@/infrastructure/env-config';
import { PAGE_ID } from '@/infrastructure/reporter/datong/id';
import { useReportPage } from '@/infrastructure/reporter/datong/report';
import { AppSlot } from '@/presentation/components/app-slot';
import { InternalPermissionWrapper } from '@/presentation/layouts/internal-permission-wrapper';
import { TDSMainPage } from '../main-pro/tds-index';
import { HomeAnimation } from './homeAnimation';
import style from './index.module.scss';

const useMobile = () => {
  const MOBILE_WIDTH = 768;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_WIDTH);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= MOBILE_WIDTH);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return [isMobile];
};

export const IndexPage = () => {
  const history = useHistory();
  useReportPage(PAGE_ID.indexMain);
  const [isMobile] = useMobile();

  const getFeatureContent = (headline: string, description: string, picture: any, infoLeft: boolean) => {
    if (infoLeft) {
      return <div className={style.tagContainer}>
        <div className={style.subContent}>
          <div>
            <div className={style.headline}>{headline}</div>
            <div className={style.desc}>{description}</div>
          </div>
        </div>
        <div><img className={style.img} src={picture} alt='' /></div>
      </div>;
    }
    return <div className={classNames(style.tagContainer, style.tagContainerBg)}>
      <div><img className={style.img} src={picture} alt='' /></div>
      <div className={style.subContent}>
        <div>
          <div className={style.headline}>{headline}</div>
          <div className={style.desc}>{description}</div>
        </div>
      </div>
    </div>;
  };

  return (
    <InternalPermissionWrapper>
      <div className={style.main}>
        <TdsNavigation isWoa activeMenu={TdsItem.Bugly} isProd={ENV.isProd} isMobile={isMobile} />
        <div className={style.introduce}>
          <div className={style.brandTitle}>
            <BrandLogo />
            <span className={style.brandText}>tds-Bugly</span>
          </div>
          <div className={style.introduceTitle}>
            <span>一种愉悦的开发方式</span>
          </div>
          <div className={style.introduceContent}>
            Bugly​ 是专业的应用质量监控与定位分析平台，致力于提供覆盖研发全流程、全平台、智能化的监控定位分析解决方案，
            助力全球开发者高效地构建高质量应用。 作为腾讯端服务（Tencent Device-oriented
            Service，简称TDS）产品联盟的核心成员，Bugly与联盟伙伴携手共建开放共赢的大前端技术生态圈。
          </div>
          <div className={style.btnContainer}>
            <Button
              size={'large'}
              type={'primary'}
              className={style.introduceBtn}
              onClick={() => history.push('/workbench/apps')}
            >开始使用<RightArrow /></Button>
            <div
              className={style.docBtn}
              onClick={() => window.open('https://docs.bugly.woa.com', '_blank')}
            >
              <div className={style.docContentBox}>帮助文档</div>
            </div>
          </div>
          <HomeAnimation />
          <div className={style.animationContent}>
            <HomeAnimationIcon className={style.animation} />
          </div>
        </div>
        <div className={style.feature}>
          {getFeatureContent(
            '监控能力升级',
            '在崩溃监控的基础上，增加了卡顿监控、内存监控、启动监控以及隐私合规，全面捕获质量问题。',
            monitor, true,
          )}
          {getFeatureContent(
            '丰富的指标体系',
            '除崩溃率、ANR率、错误率外，增加了FPS、挂起率、FOOM率、内存峰值以及启动耗时等指标。',
            indicator, false,
          )}
          {getFeatureContent(
            '动态化聚类策略',
            '支持聚类策略动态调整，分级聚类，实时聚类，兼容栈深超大的Unity、UE4聚类。',
            strategy, true,
          )}
          {getFeatureContent(
            '更多现场信息',
            '在异常堆栈及跟踪数据的基础上，增加了内存，进程，线程，FD以及更多系统日志等现场信息，方便用户分析疑难问题。',
            info, false,
          )}
          {getFeatureContent(
            '扩展分析能力',
            '通过下钻分析和对比分析，轻松掌握Issue变化情况，上报趋势以及多维度的统计分布特性。',
            analyticalAbility, true,
          )}
          {getFeatureContent(
            '多策略告警',
            '提供多任务，多维度，多策略告警支持，告警通知更清晰，权限管理更规范。',
            alert, false,
          )}
          {getFeatureContent(
            '可配置日报',
            '提供全面的质量日报数据，快速了解应用质量现状，支持业务自由配置。',
            daily, true,
          )}
        </div>

        <div className={style.mobileFeature}>
          <div className={style.bigTitle}>监控能力升级</div>
          <div className={style.featureContent}>
            在崩溃监控的基础上，增加了卡顿监控、内存监控以及启动监控，全面捕获质量问题。
          </div>
          <div className={style.featureImg}>
            <CoreIcon />
          </div>
        </div>

        <div className={style.mobileFeature}>
          <div className={style.bigTitle}>丰富的指标体系</div>
          <div className={style.featureContent}>
            除崩溃率、ANR率、错误率外，增加了FPS、挂起率、FOOM率、内存峰值以及启动耗时等指标。
          </div>
          <div className={style.featureImg}>
            <MetricIcon />
          </div>
        </div>

        <div className={style.mobileFeature}>
          <div className={style.bigTitle}>动态化聚类策略</div>
          <div className={style.featureContent}>
            支持聚类策略动态调整，分级聚类，实时聚类，兼容栈深超大的Unity、UE4聚类。
          </div>
          <div className={style.featureImg}>
            <JuleiIcon />
          </div>
        </div>

        <div className={style.mobileFeature}>
          <div className={style.bigTitle}>更多现场信息</div>
          <div className={style.featureContent}>
            在异常堆栈及跟踪数据的基础上，增加了内存，进程，线程，FD以及更多系统日志等现场信息，方便用户分析疑难问题。
          </div>
          <div className={style.featureImg}>
            <InfoIcon />
          </div>
        </div>

        <div className={style.mobileFeature}>
          <div className={style.bigTitle}>扩展分析能力</div>
          <div className={style.featureContent}>
            通过下钻分析和对比分析，轻松掌握Issue变化情况，上报趋势以及多维度的统计分布特性。
          </div>
          <div className={style.featureImg}>
            <ExtraIcon />
          </div>
        </div>

        <div className={style.mobileFeature}>
          <div className={style.bigTitle}>多策略告警</div>
          <div className={style.featureContent}>
            提供多任务，多维度，多策略告警支持，告警通知更清晰，权限管理更规范。
          </div>
          <div className={style.featureImg}>
            <AlertIcon />
          </div>
        </div>

        <div className={style.mobileFeature}>
          <div className={style.bigTitle}>可配置日报</div>
          <div className={style.featureContent}>
            提供全面的质量日报数据，快速了解应用质量现状，支持业务自由配置。
          </div>
          <div className={style.featureImg}>
            <ReportIcon />
          </div>
        </div>

        <div className={style.userList}>
          <div className={style.bigTitle}>他们也选择了Bugly</div>
          <img src={appList} className={style.picture} alt='' />
          <UserListIcon className={style.mobileImg} />
          <div className={style.startUse}>
            <div className={style.bigTitle}>让我们现在就开始体验Bugly 2.0</div>
            <Button
              type={'primary'}
              size={'large'}
              className={style.startUseBtn}
              onClick={() => history.push('/workbench/apps')}
            >开始使用</Button>
          </div>
        </div>
        <TdsFooter privacyPolicyUrl={'https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56'} isWoa={!isInternal()} />
      </div>
    </InternalPermissionWrapper>
  );
};


export const MainPage = () => (
  <Fragment>
    <AppSlot apps={[MultiApp.WOA, MultiApp.Internal]}>
      <IndexPage />
    </AppSlot>
    <AppSlot apps={[MultiApp.Pro, MultiApp.Dji, MultiApp.Sgp, MultiApp.Eu]}>
      <TDSMainPage />
    </AppSlot>
  </Fragment>
);
